/* eslint-disable camelcase */
import { anyUserCan } from 'src/types';
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import localEntityListInMenuItem from 'src/utils/mainMenuOperations/localEntityListInMenuItem';
import { id, name, row_menu, description } from 'src/utils/entityOperations/columns/basicColumns';
import showOnlyInDev from 'src/utils/mainMenuOperations/showOnlyInDev';
const controlledActions = anyUserCan();
const columns = () => {
    return [
        row_menu({ menuItemShortcuts: ['del', 'copy'] }),
        id(),
        { name: 'user_id' },
        { name: 'option_id' },
        name({ name: 'option_name' }),
        description({ name: 'option_description' }),
        { name: 'value', inlineEdit: true, editable: true },
        { name: 'option_input_type' },
        { name: 'option_group_id' },
        { name: 'hide_from_ui_display' },
    ];
};
const remoteEntityName = 'preferences.option_user_values';
const localEntityName = remoteEntityName;
const localEntity = constructLocalEntity({
    columns,
    entityLabel: 'User Preference',
    entityLabelPlural: 'User Preferences',
    remoteEntityName,
    apiVersion: 1,
    controlledActions,
    pageTitle: 'User Preferences',
});
export default localEntity;
export const user_preferences__menuItem = (params) => (Object.assign(Object.assign(Object.assign(Object.assign({ label: 'User Preferences' }, showOnlyInDev()), { icon: { name: 'mdi-keyboard-outline' }, prefetch: true }), localEntityListInMenuItem({
    localEntityNameProp: localEntityName,
    tableIdProp: localEntityName
})), params));
